<template>
  <div class="artwork-text-row-details mt-3 pa-3 grey lighten-4">
    <div class="d-flex align-center mb-2">
      <v-chip small :color="statusColor" text-color="white">{{
        statusLabel
      }}</v-chip>
      <span class="caption grey--text"
        >{{ texts.length }} text{{ texts.length === 1 ? '' : 's' }}</span
      >
      <v-spacer></v-spacer>
      <v-btn small dark color="black" @click="$emit('add', artwork)">
        <v-icon small left>add</v-icon>Add text
      </v-btn>
    </div>
    <div v-if="texts.length === 0" class="body-1 grey--text py-2">
      No text is associated with this artwork.
    </div>
    <v-list v-else dense class="transparent">
      <v-list-tile
        v-for="text in texts"
        :key="text.id"
        class="px-0"
        style="border-bottom: 1px solid #fff"
      >
        <v-icon small color="black" class="pr-2">book</v-icon>
        <div class="text-status-icons">
          <v-icon v-if="isPublic(text)" small color="green" title="Used on public page">public</v-icon>
          <v-tooltip bottom v-if="hasEnglishText(text)">
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                class="language-flag language-flag--english"
                role="img"
                aria-label="English text available"
              >🇬🇧</span>
            </template>
            <span>English text filled</span>
          </v-tooltip>
          <v-tooltip bottom v-if="hasSpanishText(text)">
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                class="language-flag language-flag--spanish"
                role="img"
                aria-label="Spanish text available"
              >🇪🇸</span>
            </template>
            <span>Spanish text filled</span>
          </v-tooltip>
        </div>
        <v-list-tile-content>
          <v-list-tile-title
            class="text-black py-0"
            style="font-size: 1.2rem"
            >{{
              text.given_filename || text.title || 'Untitled text'
            }}</v-list-tile-title
          >
          <v-list-tile-sub-title v-if="isPublic(text)"
            >Used on public page</v-list-tile-sub-title
          >
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn
            small
            flat
            round
            style="border: 1px solid #000"
            @click="$emit('edit', { artwork, text })"
          >
            <v-icon small left>edit</v-icon>Edit
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  props: { artwork: { type: Object, required: true } },
  computed: {
    texts() {
      return this.artwork.artwork_texts || []
    },
    hasPublicText() {
      return this.texts.some(
        (text) => text.id === this.artwork.representative_text_id
      )
    },
    statusLabel() {
      if (this.texts.length === 0) return 'No text'
      if (!this.hasPublicText) return 'No public text'
      return 'Public text selected'
    },
    statusColor() {
      if (this.texts.length === 0) return 'red'
      if (!this.hasPublicText) return 'orange darken-2'
      return 'green'
    },
  },
  methods: {
    isPublic(text) {
      return this.artwork.representative_text_id === text.id
    },
    hasEnglishText(text) {
      return this.hasLanguageText(text, 'has_english_content', 'content')
    },
    hasSpanishText(text) {
      return this.hasLanguageText(text, 'has_spanish_content', 'content_es')
    },
    hasLanguageText(text, flag, contentField) {
      if (typeof text[flag] === 'boolean') return text[flag]
      const content = String(text[contentField] || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&(?:nbsp|#160);/gi, ' ')
        .trim()
      return content.length > 0
    },
  },
}
</script>

<style scoped>
.text-status-icons {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  margin-right: 10px;
  min-width: 28px;
}

.language-flag {
  cursor: help;
  font-size: 16px;
  line-height: 1;
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/ArtworkTextRowDetails.vue